"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[178],{

/***/ 90231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export ButtonMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49853);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64162);
/* harmony import */ var _loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58998);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76609);










var variantClasses = {
    primary: "pyxis-btn-primary",
    secondary: "pyxis-btn-secondary",
    tertiary: "pyxis-btn-tertiary",
    brand: "pyxis-btn-brand",
    ghost: "pyxis-btn-ghost",
    white: "pyxis-btn-white"
};
var sizeClasses = {
    sm: "pyxis-btn-small",
    md: "pyxis-btn-medium",
    lg: "pyxis-btn-large",
    xl: "pyxis-btn-huge"
};
var iconSizeClasses = {
    sm: "w-4 h-4",
    md: "w-4 h-4",
    lg: "w-4 h-4",
    xl: "w-4 h-4"
};
var iconOnlySizeClasses = {
    sm: "w-10 h-10 md:w-10 md:h-10",
    md: "w-10 h-10 md:w-11 md:h-11",
    lg: "w-10 h-10 md:w-11 md:h-11",
    xl: "w-10 h-10 md:w-11 md:h-11"
};
var Button = function(props) {
    if ((0,_helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__/* .isInternalLink */ .F)(props.href)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
            href: props.href,
            locale: props.language,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                as: "span"
            }))
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props));
};
var ButtonMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Button)));
var ButtonInner = function(param) {
    var _as = param.as, as = _as === void 0 ? "a" : _as, _label = param.label, label = _label === void 0 ? "" : _label, href = param.href, onClick = param.onClick, target = param.target, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = param.size, size = _size === void 0 ? "lg" : _size, icon = param.icon, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "after" : _iconPosition, _compact = param.compact, compact = _compact === void 0 ? false : _compact, ariaLabel = param.ariaLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _download = param.download, download = _download === void 0 ? false : _download, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, _stretch = param.stretch, stretch = _stretch === void 0 ? false : _stretch, _alt = param.alt, alt = _alt === void 0 ? false : _alt;
    var Element = as === "submit" ? "button" : as;
    var props = {
        type: null,
        href: null,
        target: null,
        download: null,
        title: null,
        disabled: null
    };
    if (target === "_blank") {
        icon = "external-link";
        iconPosition = "after";
    }
    if (hideLabel) {
        ariaLabel = props.title = label;
        label = "";
    }
    label = label || "";
    iconPosition = iconPosition || "after";
    // prevent orphan icon by adding first / last word to icon
    var labelWords = label === null || label === void 0 ? void 0 : label.split(" ");
    if (as === "button") {
        props.type = "button";
    }
    if (as === "submit") {
        props.type = "button";
    }
    if (as === "a") {
        props.href = href;
        props.target = target;
    }
    if (download) {
        var ref;
        props.download = true;
        if (((ref = props.href) === null || ref === void 0 ? void 0 : ref.indexOf(".sanity.io")) > -1) props.href = "".concat(props.href, "?dl");
    }
    if (disabled) {
        props.disabled = "disabled";
    }
    var handleClick = function(e) {
        return disabled ? function() {} : onClick ? onClick(e) : function() {};
    };
    var ButtonIcon = icon ? function(param) {
        var wordBefore = param.wordBefore, wordAfter = param.wordAfter;
        var _obj;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "whitespace-nowrap break-all",
            children: [
                wordBefore && " ".concat(wordBefore),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline text-current", iconSizeClasses[size], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "mr-2", wordAfter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "ml-2", wordBefore), _obj)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_3__/* .IconLoader */ .p, {
                        icon: icon,
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block translate-y-1", iconSizeClasses[size])
                    })
                }),
                wordAfter && "".concat(wordAfter, " ")
            ]
        });
    } : null;
    var _obj;
    var sharedClasses = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, sizeClasses[size], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, variantClasses[variant], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn-alt", alt), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "inline-flex items-center justify-center", !stretch), _obj);
    // icon only button
    if (!(label === null || label === void 0 ? void 0 : label.trim().length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            "aria-label": ariaLabel || label,
            onClick: handleClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconOnlySizeClasses[size], !compact)),
                children: [
                    ButtonIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {}),
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                ]
            })
        }));
    }
    // icon + text button
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        "aria-label": ariaLabel || label,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, sizeClasses[size], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, "w-full flex", stretch)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-left break-words",
                children: ButtonIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        ButtonIcon && iconPosition === "before" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordAfter: labelWords[0]
                        }),
                        iconPosition === "before" ? labelWords.slice(1).join(" ") : labelWords.slice(0, -1).join(" "),
                        ButtonIcon && iconPosition === "after" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordBefore: labelWords[labelWords.length - 1]
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "flex",
                    children: [
                        label,
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                })
            })
        })
    }));
};
var ButtonLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "h-5 w-5 inline-flex self-center align-middle ml-2 -mb-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__/* .Spinner */ .$, {})
    });
};


/***/ }),

/***/ 12901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ButtonGroup; }
/* harmony export */ });
/* unused harmony export ButtonGroupMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90231);






var ButtonGroup = function(param) {
    var items = param.items, direction = param.direction, stretch = param.stretch, align = param.align, className = param.className;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-wrap gap-3 md:gap-4", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex-col", direction === "vertical"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "inline-flex", !stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex w-full", stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-start", direction === "horizontal" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-center", direction === "horizontal" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-end", direction === "horizontal" && align === "right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-start", direction === "vertical" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-center", direction === "vertical" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-end", direction === "vertical" && align === "right"), _obj), className),
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0 max-w-full", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "w-full", item.stretch)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item))
            }, item.label);
        })
    });
};
var ButtonGroupMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(ButtonGroup)));


/***/ }),

/***/ 55237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports ALIGN_OPTIONS, SIZE_OPTIONS, FONT_OPTIONS, TextMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var ALIGN_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .ALIGNMENTS */ .Eu, "left", "center", "right", "auto");
var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "sm", "md", "lg", "xl", "2xl");
var FONT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONTS */ .g5, "heading", "sans", "mono");
var alignClasses = {
    auto: "",
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto"
};
var sizeClasses = {
    sm: "prose-sm md:prose-md",
    md: "prose-md md:prose-base",
    lg: "prose-lg md:prose-xl",
    xl: "prose-lg md:prose-2xl",
    "2xl": "prose-lg md:prose-2xl xl:prose-3xl"
};
var fontClasses = {
    sans: "font-sans",
    mono: "font-mono",
    heading: "font-sans"
};
var Text = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "div" : _as, background = param.background, color = param.color, _align = param.align, align = _align === void 0 ? "left" : _align, _size = param.size, size = _size === void 0 ? "lg" : _size, className = param.className, _font = param.font, font = _font === void 0 ? "sans" : _font;
    var Element = as;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words prose font-regular leading-relaxed", "prose-strong:font-bold prose-strong:text-current", "prose-a:underline prose-a:underline-offset-4", alignClasses[align], sizeClasses[size], fontClasses[font], color ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color] : background ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .proseClasses */ .fh[background] : "text-current", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "prose-a:text-action-base", !background || background === "white" || background === "neutral-95")),
            children: children
        })
    });
};
var TextMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Text)));


/***/ }),

/***/ 37794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; }
/* harmony export */ });
/* unused harmony exports SIZE_OPTIONS, WEIGHT_OPTIONS, TitleMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl");
var WEIGHT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONT_WEIGHTS */ .Xw, "book", "bold");
var sizeClasses = {
    xs: "text-title-xs-sm md:text-title-xs-md lg:text-title-xs-lg",
    sm: "text-title-sm-sm md:text-title-sm-md lg:text-title-sm-lg",
    md: "text-title-md-sm md:text-title-md-md lg:text-title-md-lg",
    lg: "text-title-lg-sm md:text-title-lg-md lg:text-title-lg-lg",
    xl: "text-title-xl-sm md:text-title-xl-md lg:text-title-xl-lg",
    "2xl": "text-title-2xl-sm md:text-title-2xl-md lg:text-title-2xl-lg",
    "3xl": "text-title-3xl-sm md:text-title-3xl-md lg:text-title-3xl-lg",
    "4xl": "text-title-4xl-sm md:text-title-4xl-md lg:text-title-4xl-lg"
};
var weightClasses = {
    book: "font-book",
    bold: "font-bold"
};
var Title = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "h2" : _as, _size = param.size, size = _size === void 0 ? "sm" : _size, _weight = param.weight, weight = _weight === void 0 ? "bold" : _weight, className = param.className, _color = param.color, color = _color === void 0 ? "neutral-base" : _color, eyebrow = param.eyebrow, _eyebrowColor = param.eyebrowColor, eyebrowColor = _eyebrowColor === void 0 ? "brand-base" : _eyebrowColor;
    var ref;
    var Element = as;
    var titleWords = (ref = children === null || children === void 0 ? void 0 : children.toString()) === null || ref === void 0 ? void 0 : ref.trim().split(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            eyebrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block mb-[.5em]", sizeClasses.md, _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[eyebrowColor], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "opacity-75", eyebrowColor === "white")),
                children: [
                    eyebrow,
                    "\xa0"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words inline-block", "font-sans", "flex flex-col whitespace-pre-line", _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color], sizeClasses[size], weightClasses[weight], className),
                children: typeof children === "string" ? titleWords.join(" ") : children
            })
        ]
    });
};
var TitleMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Title)));


/***/ }),

/***/ 18429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArticleFeed": function() { return /* binding */ ArticleFeed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80969);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69779);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pyxis_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98647);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_module_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55237);
/* harmony import */ var _components_module_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37794);
/* harmony import */ var _components_module_Wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83118);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43470);
/* harmony import */ var _helpers_utils_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80109);
/* harmony import */ var _CardGrid_ComposableCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76006);













var PAGE_SIZE = 9;
var ArticleFeed = function(param) {
    var theme = param.theme, feedType = param.feedType, items = param.items;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    // console.log('feed type', feedType);
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_6__/* .PageContext */ .z), config = ref9.config, locale = ref9.locale;
    var translations = config.translations;
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(1), 2), page = ref10[0], setPage = ref10[1];
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(null), 2), nextActiveTag = ref11[0], setNextActiveTag = ref11[1];
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(null), 2), nextActiveCountry = ref12[0], setNextActiveCountry = ref12[1];
    var ref13 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(null), 2), activeTag = ref13[0], setActiveTag = ref13[1];
    var ref14 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(null), 2), activeCountry = ref14[0], setActiveCountry = ref14[1];
    var hasActiveFilters = [
        activeTag,
        nextActiveTag,
        activeCountry,
        nextActiveCountry, 
    ].filter(Boolean).length;
    items = items === null || items === void 0 ? void 0 : items.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item), {
            type: "card.composable"
        });
    });
    // filter by tag
    var filteredItems = activeTag ? items === null || items === void 0 ? void 0 : items.filter(function(param) {
        var tags = param.tags;
        return tags === null || tags === void 0 ? void 0 : tags.some(function(param) {
            var slug = param.slug;
            return slug === activeTag;
        });
    }) : items;
    // filter by country
    filteredItems = activeCountry ? filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.filter(function(param) {
        var countries = param.countries;
        return countries === null || countries === void 0 ? void 0 : countries.some(function(param) {
            var slug = param.slug;
            return slug === activeCountry;
        });
    }) : filteredItems;
    // paginate items
    var paginatedItems = filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.slice(0, PAGE_SIZE * page);
    // show load more button
    var hasMore = (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > (paginatedItems === null || paginatedItems === void 0 ? void 0 : paginatedItems.length);
    // handle load more
    var onLoadMoreClick = function() {
        setPage(function(page) {
            return ++page;
        });
    };
    // generate set of unique used tags
    var availableTags = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        return getUniqueTags(items, "tags");
    }, [
        items
    ]);
    var availableCountries = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
        return getUniqueTags(items, "countries");
    }, [
        items
    ]);
    var onSubmitClick = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function() {
        setPage(1);
        setActiveCountry(nextActiveCountry);
        setActiveTag(nextActiveTag);
    }, [
        nextActiveTag,
        nextActiveCountry
    ]);
    var onResetClick = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function() {
        setPage(1);
        setNextActiveCountry(null);
        setNextActiveTag(null);
        setActiveCountry(null);
        setActiveTag(null);
    }, []);
    console.log("article items ", items);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_module_Wrapper__WEBPACK_IMPORTED_MODULE_5__/* .Wrapper */ .i, {
            theme: theme,
            children: [
                (Boolean(availableCountries === null || availableCountries === void 0 ? void 0 : availableCountries.length) || Boolean(availableTags === null || availableTags === void 0 ? void 0 : availableTags.length)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-wrap gap-y-4 gap-x-10 items-end pb-20 relative z-20",
                    children: [
                        Boolean(availableCountries === null || availableCountries === void 0 ? void 0 : availableCountries.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 min-w-40",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pyxis_react__WEBPACK_IMPORTED_MODULE_1__.Select, {
                                items: [
                                    {
                                        value: null,
                                        label: (translations === null || translations === void 0 ? void 0 : (ref = translations.article_feed_select_all_countries) === null || ref === void 0 ? void 0 : ref[locale]) || "…"
                                    }, 
                                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(availableCountries.map(function(param) {
                                    var title = param.title, slug = param.slug;
                                    return {
                                        value: slug,
                                        label: title
                                    };
                                }))),
                                name: "country",
                                onChange: function(e, value) {
                                    setPage(1);
                                    setNextActiveCountry(value);
                                },
                                value: nextActiveCountry,
                                label: (translations === null || translations === void 0 ? void 0 : (ref1 = translations.article_feed_countries_label) === null || ref1 === void 0 ? void 0 : ref1[locale]) || "Country",
                                size: "m",
                                className: "[&_input]:rounded-[0.5em]"
                            })
                        }),
                        Boolean(availableTags === null || availableTags === void 0 ? void 0 : availableTags.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 min-w-40",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pyxis_react__WEBPACK_IMPORTED_MODULE_1__.Select, {
                                items: [
                                    {
                                        value: null,
                                        label: (translations === null || translations === void 0 ? void 0 : (ref2 = translations.article_feed_select_all_categories) === null || ref2 === void 0 ? void 0 : ref2[locale]) || "…"
                                    }, 
                                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(availableTags.map(function(param) {
                                    var title = param.title, slug = param.slug;
                                    return {
                                        value: slug,
                                        label: title
                                    };
                                }))),
                                name: "category",
                                onChange: function(e, value) {
                                    setPage(1);
                                    setNextActiveTag(value);
                                },
                                value: nextActiveTag,
                                label: (translations === null || translations === void 0 ? void 0 : (ref3 = translations.article_feed_categories_label) === null || ref3 === void 0 ? void 0 : ref3[locale]) || "Category",
                                size: "m",
                                className: "[&_input]:rounded-[0.5em]"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex no-wrap gap-2 pb-0.5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pyxis_react__WEBPACK_IMPORTED_MODULE_1__.Button, {
                                    variant: "primary",
                                    size: "l",
                                    onClick: onSubmitClick,
                                    disabled: activeCountry === nextActiveCountry && activeTag === nextActiveTag,
                                    children: (translations === null || translations === void 0 ? void 0 : (ref4 = translations.article_feed_search_label) === null || ref4 === void 0 ? void 0 : ref4[locale]) || "Search"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pyxis_react__WEBPACK_IMPORTED_MODULE_1__.Button, {
                                    variant: "ghost",
                                    size: "l",
                                    onClick: onResetClick,
                                    disabled: !hasActiveFilters,
                                    children: (translations === null || translations === void 0 ? void 0 : (ref5 = translations.article_feed_reset_label) === null || ref5 === void 0 ? void 0 : ref5[locale]) || "Reset"
                                })
                            ]
                        })
                    ]
                }),
                (paginatedItems === null || paginatedItems === void 0 ? void 0 : paginatedItems.filter(Boolean).length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 !gap-10",
                    children: paginatedItems === null || paginatedItems === void 0 ? void 0 : paginatedItems.map(function(item) {
                        // console.log(formatDates(item));
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardGrid_ComposableCard__WEBPACK_IMPORTED_MODULE_7__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item), {
                                badge: item.date,
                                themeName: feedType,
                                text: (0,_helpers_utils_string__WEBPACK_IMPORTED_MODULE_12__/* .truncate */ .$G)(item.text || "", 120)
                            }))
                        }, item._key);
                    })
                }) : activeCountry || activeTag ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-3 text-neutral-25",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Title__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
                            size: "3xl",
                            color: "neutral-25",
                            children: (translations === null || translations === void 0 ? void 0 : (ref6 = translations.article_feed_no_results_title) === null || ref6 === void 0 ? void 0 : ref6[locale]) || "No results found"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                            size: "xl",
                            children: (translations === null || translations === void 0 ? void 0 : (ref7 = translations.article_feed_no_results_text) === null || ref7 === void 0 ? void 0 : ref7[locale]) || "Please try an alternative combination of filters."
                        })
                    ]
                }) : null,
                hasMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center pt-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pyxis_react__WEBPACK_IMPORTED_MODULE_1__.Button, {
                        variant: "primary",
                        size: "l",
                        onClick: onLoadMoreClick,
                        children: (translations === null || translations === void 0 ? void 0 : (ref8 = translations.article_feed_load_more_label) === null || ref8 === void 0 ? void 0 : ref8[locale]) || "Load more"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(ArticleFeed));
var getUniqueTags = function(items, key) {
    if (!key) return items;
    var usedTags = {};
    var tags = items === null || items === void 0 ? void 0 : items.reduce(function(acc, item) {
        if (item[key]) {
            item[key].forEach(function(tag) {
                if (!usedTags[tag.slug]) {
                    usedTags[tag.slug] = tag.slug;
                    acc.push(tag);
                }
            });
        }
        return acc;
    }, []);
    return tags === null || tags === void 0 ? void 0 : tags.sort(function(a, b) {
        return a.title.localeCompare(b.title);
    });
};


/***/ })

}]);